export default __webpack_public_path__ + "static/media/graha-logo-white.d567b90b.png";